import React from 'react'
import Layout from '../../Layout'
import ActiveOrderPeykContainer from '../../../../Components/OrdersPeykPart/ActiveOrderPeykContainer/ActiveOrderPeykContainer'

const ActiveOrderPeyk = () => {
  return (
    <Layout>
      <ActiveOrderPeykContainer/>
    </Layout>
  )
}

export default ActiveOrderPeyk